<template>
    <div class="c-modal-wrapper c-has-dark-blue-header">
      <!-- Overlay loader -->
      <overlay-loader v-if="isLoading.length > 0"></overlay-loader>         
      <!-- Application Header -->
      <header class="c-modal-header">
        <div class="c-responsive-container">
          <div class="c-as-block c-has-header-buttons">
            <div class="c-grid-row">
              <div class="c-col-6 c-align-right">
                <button class="c-btn" v-on:click="cancelChanges()"><i aria-hidden="true" class="fa fa-times c-ux-color-danger"></i> <b>Otkaži</b></button>                
              </div>
              <div class="c-col-6 c-align-left">
                <button class="c-btn" v-on:click="saveChanges()"><i aria-hidden="true" class="fa fa-check c-ux-color-success"></i> <b>Sačuvaj</b></button>                
              </div>
            </div>
          </div>
        </div>
      </header>
      <!-- Body content -->
      <div class="c-modal-body c-has-skewed-background c-to-full-bottom">
        <div class="c-responsive-container">
          <form class="c-p-10" v-on:submit.prevent>
            <div class="c-info-title-labels-wrap">
              <button class="c-info-icon"><i class="fa fa-info-circle" aria-hidden="true"></i></button>
              <div class="c-info-title"><b>Kreiranje novog događaja</b></div>
            </div>            
            <!-- Event Date -->
            <div class="c-grid-row">
              <div class="c-form-group c-blue-style" v-bind:class="{'c-has-error' : formVars.eventDate.showError}">
                <label for="event-date" v-if="formVars.eventDate.showError">{{formVars.eventDate.errorMsg}}</label>
                <label for="event-date" v-else>Datum</label>
                <div class="c-input-group">
                  <datepicker v-model="formVars.eventDate.model" input-class="c-form-control" id="event-date" name="event-date"></datepicker>
                  <div class="c-input-addon-wrap">
                    <button class="c-addon-item"><i class="fa fa-calendar" aria-hidden="true"></i></button>
                  </div>
                </div>
              </div>
            </div>
            <!-- Band name -->
            <div class="c-grid-row">
              <div class="c-form-group c-blue-style" v-bind:class="{'c-has-error' : formVars.eventName.showError}">
                <label for="band-name" v-if="formVars.eventName.showError">{{formVars.eventName.errorMsg}}</label>
                <label for="band-name" v-else>Naziv benda</label>
                <input type="text" class="c-form-control" id="band-name" name="band-name" 
                v-model="formVars.eventName.model">
              </div>
            </div>
            <!-- Venue type -->
            <div class="c-grid-row">
              <div class="c-form-group c-blue-style" v-bind:class="{'c-has-error' : formVars.eventVenue.showError}">
                <label for="venue-type" v-if="formVars.eventVenue.showError">{{formVars.eventVenue.errorMsg}}</label>
                <label for="venue-type" v-else>Vrsta rezervacije</label>
                <select class="c-form-control" id="venue-type" name="venue-type" v-model="formVars.eventVenue.model">
                  <option disabled v-bind:value="null">Izaberite tip rezervacije</option>
                  <option 
                    v-for="(singleVenue, key) in listOfAllVenues" 
                    v-bind:value="key"
                    v-if="singleVenue.name"
                  >{{singleVenue.name}}</option>
                </select>             
              </div>
            </div>
            <!-- Ticket price / Number of sold tickets -->
            <div class="c-grid-row">
              <!-- Ticket price -->
              <div class="c-col-6">
                <div class="c-form-group c-blue-style">
                  <label for="ticket-price">Cena ulaznice</label>
                  <div class="c-input-group">
                    <input type="text" class="c-form-control" id="ticket-price" name="ticket-price"
                    v-model="formVars.ticketPrice.model">
                    <div class="c-input-addon-wrap">                    
                      <select class="c-addon-item" v-model="formVars.ticketPriceCurrency.model">
                        <option disabled v-bind:value="null">Izaberi</option>
                        <option 
                          v-for="(singleUnitType, key) in listOfCurrencyUnits" 
                          v-bind:value="key"
                          v-if="singleUnitType.title"
                        >{{singleUnitType.title}}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Band price -->
              <div class="c-col-6">
                <div class="c-form-group c-blue-style">
                  <label for="ticket-price">Cena benda</label>
                  <div class="c-input-group">
                    <input type="text" class="c-form-control" id="ticket-price" name="ticket-price"
                    v-model="formVars.performerPrice.model">
                    <div class="c-input-addon-wrap">
                      <select class="c-addon-item" v-model="formVars.performerPriceCurrency.model">
                        <option disabled v-bind:value="null">Izaberi</option>
                        <option 
                          v-for="(singleUnitType, key) in listOfCurrencyUnits" 
                          v-bind:value="key"
                          v-if="singleUnitType.title"
                        >{{singleUnitType.title}}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Form divider -->
            <!-- <div class="c-form-divider">Dodatne opcije</div> -->
            <!-- Visible for all switch -->
            <!-- <div class="c-grid-row">
              <div class="c-form-group c-blue-style">
                <label for="visible-for-all">Da li je događaj vidljiv za svo osoblje m:{{formVars.eventVisibleForAll.model}}</label>
                <div class="c-form-switch">
                  <label class="c-switch-button">
                    <input type="checkbox" v-on:click="formVars.eventVisibleForAll.model = !formVars.eventVisibleForAll.model" v-model="formVars.eventVisibleForAll.model">
                    <div class="c-slider">
                      <div class="c-options-hint-back-wrapper">
                        <div class="c-grid-row"><div class="c-col-6"><b>NE</b></div><div class="c-col-6"><b>DA</b></div></div>
                      </div>
                      <span class="c-slider-btn">
                        <div class="c-align-this">
                          <span class="c-has-vertical-lines c-left"></span>
                          <b v-if="formVars.eventVisibleForAll.model == true" class="c-ux-color-success">DA</b>
                          <b v-else class="c-ux-color-danger">NE</b>
                          <span class="c-has-vertical-lines c-right"></span>
                        </div>
                      </span>
                    </div>
                  </label>
                </div>
              </div>
            </div> -->
          </form>
        </div>        
      </div>
    </div>
</template>

<script>
import router from '@/router/index'
import EventBus from '@/EventBus'
import Datepicker from 'vuejs-datepicker';
import OverlayLoader from "@/components/helpers/OverlayLoader";
import moment from 'moment'
import {firebaseDB} from '@/firebase';
export default {
  name: 'ModalCreateNewEvent',
  props: ['inputModalData'],
  components: {
      Datepicker: Datepicker,
      OverlayLoader: OverlayLoader
  },
  data () {
    return {
      msg: 'ModalCreateNewEvent modal',
      isLoading: [],
      listOfAllVenues: {},
      listOfCurrencyUnits: {},
      tempSelectedVenueObject: null,
      tempListOfAllTablesForEvent: {},
      newEventKey: null,
      newReservationsOfEventKey: null,
      formVars: {
        isValid: false,
        isSubmited: false,
        eventDate: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Datum je obavezan!'
        },
        eventName: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Naziv je obavezan!'
        },
        eventVenue: {
          model: null,
          isLoading: [1],
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Tip rezervacija je obavezan!'
        },
        ticketPrice: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        ticketPriceCurrency: {
          model: null,
          showError: false
        },     
        performerPrice: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        performerPriceCurrency: {
          model: null,
          showError: false
        },
        eventVisibleForAll: {
          model: true
        }
      },      
      resolve: null,
      reject: null
    }
  },
  watch: {
    'formVars.eventDate.model' : function (newValue){      
      if (this.formVars.eventDate.showError == true){
        this.formVars.eventDate.showError = false;
      }
      //console.log('formVars.eventDate.model changed to: ' + newValue);
    },
    'formVars.eventName.model' : function (newValue){
      if (this.formVars.eventName.showError == true){
        this.formVars.eventName.showError = false;
      }
    },
    'formVars.eventVenue.model' : function (newValue){
      if (this.formVars.eventVenue.showError == true){
        this.formVars.eventVenue.showError = false;
      }
    },
    'formVars.ticketPriceCurrency.model' : function (newValue){
      //console.log('formVars.ticketPriceCurrency.model changed to: ' + newValue);
    },
    'formVars.performerPriceCurrency.model' : function (newValue){
      //console.log('formVars.performerPriceCurrency.model changed to: ' + newValue);
    }
  },
  methods: {
    // ~ When we want to save changes created on this modal
    saveChanges: function (){
      ///============
      var indexCounter = 0;
      for (var key in this.listOfAllVenues) {
        if (this.listOfAllVenues.hasOwnProperty(key)) {
          var obj = this.listOfAllVenues[key];
          if (obj.key == this.formVars.eventVenue.model){
            this.tempSelectedVenueObject = obj;
            //// = When we found Venue type that user selected, now we will create list of tables from that venue that will be connected as reservations to new event
            break;
          }
          //==========
          indexCounter++;
        }
      }
      //
      ///============      
      //console.log('SaveChanges end');
      var isFormValid = this.returnNewEventFormState();
      //var isFormValid = false;
      if (isFormValid === true && this.formVars.isSubmited === false){
        this.formVars.isSubmited = true;
        this.isLoading.push(1);
        //
        this.newEventKey = firebaseDB.ref().child('listOfFutureEvents').push().key;
        this.newReservationsOfEventKey = firebaseDB.ref().child('listOfAllEventsReservations').push().key;
        firebaseDB.ref('listOfFutureEvents').child(this.newEventKey).set({
          //Date of event
          //eventDate: this.formVars.eventDate.model.toString(),
          eventDate: moment(this.formVars.eventDate.model).utc().locale('en').toISOString(),
          //Event name
          eventName: this.formVars.eventName.model,
          //Event Venue type (where event will be placed)
          eventVenue: this.formVars.eventVenue.model,
          //Key of Reservations object where we will store all reservations related to this event
          eventReservationsKey: this.newReservationsOfEventKey,
          //Event ticket price
          ticketPrice: this.formVars.ticketPrice.model,
          //Ticket price currency (RSD, EUR)
          ticketPriceCurrency: this.formVars.ticketPriceCurrency.model,
          //Number of sold tickets
          //ticketsSold: this.formVars.ticketsSold.model,
          //Performer/Band price
          performerPrice: this.formVars.performerPrice.model,
          //Performer/Band price currency (RSD, EUR)
          performerPriceCurrency: this.formVars.performerPriceCurrency.model,
          //Income from sold drinks
          //drinkIncome: this.formVars.drinkIncome.model,
          //Is event visible for all (all admins or only high level admin roles)
          eventVisibleForAll: this.formVars.eventVisibleForAll.model,
          //event uid/key
          eventUid: this.newEventKey
        }).then(
          function (response) {
            this.getTableWithAllTablesForReservation();            
            ///// =======================================         
            //when we created new event in 'listOfFutureEvents', we must also create new entry for reservations connected for that event
            firebaseDB.ref('listOfAllEventsReservations').child(this.newReservationsOfEventKey).set(this.tempListOfAllTablesForEvent).then(
              function (response) {
                //console.log('Firebase RESERVATIONS list of tables Create succ: ' + JSON.stringify(response, null, 2));
                var resultToReturn = {
                  tempMsg: 'ModalCreateNewEvent returns Yes'
                }
                this.resolve(resultToReturn);
              }.bind(this),
              function (error){
                console.log('Firebase RESERVATIONS list of tables Create ERROR: ' + JSON.stringify(error, null, 2));
              }.bind(this)
            );
          }.bind(this),
          function (error){
            console.log('Firebase Event Create ERROR: ' + JSON.stringify(error, null, 2));
          }.bind(this)
        );
      }
    },
    returnNewEventFormState: function () {
      var returnValue = true;
      //
      if (!this.formVars.eventDate.model){
        returnValue = false;
        this.formVars.eventDate.showError = true;
      }
      if (!this.formVars.eventName.model){
        returnValue = false;
        this.formVars.eventName.showError = true;
      }
      if (!this.formVars.eventVenue.model){
        returnValue = false;
        this.formVars.eventVenue.showError = true;
      }
      return returnValue;
    },
    // ~ 
    getTableWithAllTablesForReservation: function () {
      if (this.tempSelectedVenueObject && this.tempSelectedVenueObject.tableGroups){
        var counterSpec = 0;
        for (var prop in this.tempSelectedVenueObject.tableGroups) {
          counterSpec++;
          if (this.tempSelectedVenueObject.tableGroups[prop].shortName && this.tempSelectedVenueObject.tableGroups[prop].totalNumber){
            var shortName = this.tempSelectedVenueObject.tableGroups[prop].shortName;
            var totalNumber = this.tempSelectedVenueObject.tableGroups[prop].totalNumber;
            var totalNumberOfTables = parseInt(totalNumber);
            for (var s = 0; s < totalNumberOfTables; s++){
              ////
              var threeDigitNumber = ("00" + (s+1)).slice(-3);
              //generate unique id for each table inside reservation record
              var newTableUID = this.tempSelectedVenueObject.key + "_" + shortName + "_" + threeDigitNumber;
              //              
              var singleTableObject = {
                uid: newTableUID,
                tableNumber: (s+1),
                tableShortName: shortName,
                tableLocked: {// da li je sto/rezervacija zakljucana (npr neki administrator jednostavno zeli da zakljuca sto tako da ga nijedan drugi administrator ne moze rezervisati)
                  status: false,// zakljucan/nije zakljucan
                  lockedBy: null,//lockedBy: 'aDMn_nmbr8923' - kljuc administratora koji je zakljucao ovaj sto
                  lockedDate: null// datum i vreme kada je sto zakljucan od strane nekog admina
                },
                tableCheckedInStatus: 1// status rezervacije (1=Ceka se gost da dodje, 2=Gost je dosao, 3=Gost nije dosao), koristi se da se zna da li je gost dosao ili je ispalio
              };
              ///////////
              this.tempListOfAllTablesForEvent[newTableUID] = singleTableObject;
            }
          }
        }    
      }
    },
    // ~ When we want to discard changes
    cancelChanges: function (){
      this.reject();
    }
  },
  created () {
    //console.log('~ created- ModalCreateNewEvent component!');
    if (this.inputModalData){
      //console.log('inputModalData: ' + JSON.stringify(this.inputModalData, null, 2) );
      if (this.inputModalData.dataForModal && this.inputModalData.dataForModal.listOfVenueTypes){
        this.listOfAllVenues = this.inputModalData.dataForModal.listOfVenueTypes;
      }
      if (this.inputModalData.dataForModal && this.inputModalData.dataForModal.listOfCurrencyUnits){
        this.listOfCurrencyUnits = this.inputModalData.dataForModal.listOfCurrencyUnits;
      }      
      this.resolve = this.inputModalData.resolve;
      this.reject = this.inputModalData.reject;
    }
  },
  mounted () {
    //console.log('~ mounted - ModalCreateNewEvent component!');
  },
  destroyed () {
    //console.log('~ destroyed- ModalCreateNewEvent component!');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/futureEvents/ModalCreateNewEvent.vue